/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const location = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M6.714 15h2.572m.16-9.5a1.446 1.446 0 1 1-2.893 0 1.446 1.446 0 0 1 2.893 0Zm3.054-.063a4.38 4.38 0 0 1-.382 1.789L9.23 12.514c-.251.43-.717.7-1.231.7-.514 0-.98-.27-1.235-.707L3.872 7.205A4.367 4.367 0 0 1 3.5 5.437C3.5 2.987 5.513 1 8 1s4.5 1.988 4.5 4.437Z"
    />
  </svg>
)
export default location
